module.exports = __webpack_public_path__ + "static/media/rocket.1f058399.png";